<template>
    <div class="panel-body" style="">
        <div v-if="canAssign !== 'no'">
            <div class="row">
                <div class="col-lg-7">
                    <running-tasks
                            :csrfToken="csrfToken"
                            :user-id="userId"
                            ref="running"
                            :updateAssignableTasks="updateAssignableTasks"
                    >
                    </running-tasks>
                </div>
                <div class="col-lg-5">
                    <assignable-task-list
                            :can-search="canSearch"
                            :available-actions="JSON.parse(availableActions)"
                            :user-id="userId"
                            :csrf-token="csrfToken"
                            :fetchRunningTasks="fetchRunningTasks"
                            :fetchCurrentTasksAndProjectedEarnings="fetchCurrentTasksAndProjectedEarnings"
                            :countries="countries"
                            ref="assignable"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <completed-tasks :user-id="userId"></completed-tasks>
                </div>
            </div>

        </div>
        <div class="row" v-if="canAssign === 'no'">
            <div class="col-lg-6">
                <running-tasks :csrfToken="csrfToken" :user-id="userId"></running-tasks>
            </div>
            <div class="col-lg-6">
                <completed-tasks :user-id="userId"></completed-tasks>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: [
            'csrfToken',
            'canAssign',
            'availableActions',
            'userId',
            'viewingSelf',
            'countries'
        ],

        data() {
            return {
                canSearch: this.viewingSelf === '0' || this.canAssign === 'any'
            };
        },

        mounted() {
        },

        computed: {},

        methods: {
            updateAssignableTasks: function(action) {
                if (this.$refs.assignable !== undefined
                    && String(this.$refs.assignable.selectedActionId) === String(action.code)) {
                    console.log('load');
                    this.$refs.assignable.fetchTasks(action);
                }
            },
            fetchRunningTasks: function() {
                this.$refs.running.fetchRunningTasks();
            },
            fetchCurrentTasksAndProjectedEarnings: function() {
                this.$refs.running.fetchCurrentTasksAndProjectedEarnings();
            },
        },
    };
</script>
